import { render, staticRenderFns } from "./new-category-dialog.vue?vue&type=template&id=a70ac3ec&scoped=true"
import script from "./new-category-dialog.vue?vue&type=script&lang=js"
export * from "./new-category-dialog.vue?vue&type=script&lang=js"
import style0 from "./new-category-dialog.vue?vue&type=style&index=0&id=a70ac3ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70ac3ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a70ac3ec')) {
      api.createRecord('a70ac3ec', component.options)
    } else {
      api.reload('a70ac3ec', component.options)
    }
    module.hot.accept("./new-category-dialog.vue?vue&type=template&id=a70ac3ec&scoped=true", function () {
      api.rerender('a70ac3ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/new-category-dialog.vue"
export default component.exports